module.exports = __webpack_public_path__ + "static/media/16.bb2453a7.jpeg";